import { render, staticRenderFns } from "./ComplaintCreationSecondStepForm.vue?vue&type=template&id=bb909e9e&scoped=true&lang=pug&"
import script from "./ComplaintCreationSecondStepForm.vue?vue&type=script&lang=ts&"
export * from "./ComplaintCreationSecondStepForm.vue?vue&type=script&lang=ts&"
import style0 from "./ComplaintCreationSecondStepForm.vue?vue&type=style&index=0&id=bb909e9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb909e9e",
  null
  
)

export default component.exports